import React from 'react';
import { setImage } from '../../helper';
import noImage from '../../../assets/images/no-image.png';
import NoImageCompany from '../../../assets/images/noImageComp.svg';

export function CompanyStampSetting({ obj, handleImageUpload }) {
  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  return (
    <div className="d-flex ">
      <figure className="stamp-navigation flex-fill">
        {obj?.iconCompanyPath ? (
          <img src={setImage(obj?.iconCompanyPath || noImage)} alt="Company Logo" onError={handleImageError} className="company-logo img-fluid" />
        ) : (
          <img src={NoImageCompany} className="img-fluid" alt="" />
        )}
      </figure>
      <button type="button" aria-label="Upload" onClick={() => handleImageUpload('company_stamp', '')} className="btn p-0 px-1 d-inline-flex h-100 mt-auto">
        <i className="icon icon-Upload-1 f-20" />
      </button>
    </div>
  );
}

export default CompanyStampSetting;
